import { render, staticRenderFns } from "./ActualitesComponent.vue?vue&type=template&id=3edf2820&"
import script from "./ActualitesComponent.vue?vue&type=script&lang=js&"
export * from "./ActualitesComponent.vue?vue&type=script&lang=js&"
import style0 from "./ActualitesComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports